define('modules/reporting/campaigns/technology/views/panel',['require','jQuery','Underscore','collections/campaignReport','text!../templates/layout.html','modules/reporting/campaigns/models/metricCollections','modules/reporting/utils/reportingComm','T1','T1Layout','T1Permissions','T1PerformanceTimer','T1UtilsAsync','T1View','text!../templates/panel.html','modules/reporting/campaigns/utils/reportingUtils'],function (require) {
  "use strict";

  const $ = require("jQuery");
  const _ = require("Underscore");
  const CampaignReport = require("collections/campaignReport");
  const layout = require("text!../templates/layout.html");
  const MetricColl = require("modules/reporting/campaigns/models/metricCollections");
  const ReportingComm = require("modules/reporting/utils/reportingComm");
  const T1 = require("T1");
  const T1Layout = require("T1Layout");
  const T1Permissions = require("T1Permissions");
  const T1Timer = require("T1PerformanceTimer");
  const T1UtilsAsync = require("T1UtilsAsync");
  const T1View = require("T1View");
  const template = require("text!../templates/panel.html");
  const Utils = require("modules/reporting/campaigns/utils/reportingUtils");
  const GAMap = Object.freeze({
    campaignApiLoad: "RPTG:TECH:SUM:API:CAMPAIGN",
    campaignNestedApiLoad: "RPTG:TECH:API:CAMPAIGN",
    combinedLoad: "RPTG:TECH:API:LOAD:TOTAL",
    dim1ApiLoad: "RPTG:TECH:SUM:API:",
    dim1NestedApiLoad: "RPTG:TECH:API:",
    dim2ApiLoad: "RPTG:TECH:SUM:API:",
    dim2NestedApiLoad: "RPTG:TECH:API:",
    totalApiLoad: "RPTG:TECH:SUM:API:TOTAL",
    totalNestedApiLoad: "RPTG:TECH:API:TOTAL"
  });
  const trackingSection = "Reporting - Technology";
  const id = "device_technology";
  let comm, timerValue;
  return T1View.extend({
    dim1Key: "strategy_id",
    dim2Key: "",
    dimKey_device_type: "device_type",
    dimKey_inventory_type: "inventory_type",
    template: template,
    urlSuffix: "",
    section: "technology",
    dataEvents: {
      reportModel: {
        "change:tempDimension": "loadTempDimensions",
        "change:tempDim2": "loadTempDimensions",
        "change:campaignBenchmarkOn": function () {
          T1.EventHub.publish("change:campaignBenchmarkOn");
        },
        "change:columnKeys": function () {
          T1.EventHub.publish("change:columnKeys");
        },
        "change:dimension": "changeDimension",
        "change:dim2": "changeDimension",
        "change:dimensionItems": function () {
          T1.EventHub.publish(`change:dimensionItems:${id}`);
        },
        "change:hiddenCount": function () {
          T1.EventHub.publish("change:hiddenCount");
        },
        "change:highlightedItem": function (model) {
          T1.EventHub.publish("change:highlightedItem", model);
        },
        "change:filteredInItems": "getTotalData",
        "change:filteredOutItems": function () {
          if (this.dim2Key) {
            this.prevDim1Key = null;
            this.changeDimension();
          } else {
            T1.EventHub.publish("change:filteredOutItems");
          }
        },
        "change:filteredOutItemsDim2": function () {
          this.prevDim2Key = null;
          this.changeDimension();
        }
      },
      campaign: {
        "change:start_end": function () {
          const {
            campaign: campaign,
            reportModel: reportModel
          } = this;
          this.report.start = campaign.get("start");
          this.report.end = campaign.get("end");
          this.report.isCTD = campaign.get("isCTD");
          reportModel.set({
            isCTD: this.report.isCTD
          });
          reportModel.resetUIStates();
          this.load();
        }
      }
    },
    eventhubEvents: {
      "reports:select:campaign": function (args) {
        if (this.currentReportId !== args.id) {
          this.report.id = args.id;
        }
      },
      "daily:grid:inited": function () {
        this.gridInited = true;
        this.getTotalData();
      },
      "set:moreFilters": function () {
        this.load();
      },
      "remove:dim2": function (isReloadNeeded) {
        const {
          collection2: collection2,
          tempDimensionCollection2: tempDimensionCollection2
        } = comm.dataGroup;
        this.tempDim2Data = null;
        collection2.loaded = false;
        collection2.unregister();
        collection2.reset();
        tempDimensionCollection2.loaded = false;
        tempDimensionCollection2.unregister();
        tempDimensionCollection2.reset();
        if (isReloadNeeded) {
          this.changeDimension();
        }
      },
      "toggle:loader": function (show) {
        this.toggleLoader(show);
      }
    },
    initialize(args) {
      let reportModel;
      const self = this;
      const models = args.models;
      const fetchOptions = {
        dimensions: null,
        end_date: null,
        filter: "campaign_id=",
        precision: 2,
        start_date: null,
        time_rollup: null,
        v2: ""
      };
      function fetchURL() {
        const opts = $.extend({}, this.fetchOptions);
        opts.filter += String(this.id);
        return `${T1.RPT_API_ROOT + this.urlString}?${$.param(opts)}`;
      }
      function fetchURL2() {
        const opts = $.extend({}, this.fetchOptions);
        opts.filter += String(this.id) + this.filteredDimensionIDs + self.getMoreFilters();
        return `${T1.RPT_API_ROOT + this.urlString}?${$.param(opts)}`;
      }
      function makeFetchURL(techFilter) {
        return function () {
          const opts = $.extend({}, this.fetchOptions);
          opts.filter += String(this.id) + (techFilter ? self.filterParams || "" : "") + self.getMoreFilters(techFilter);
          return `${T1.RPT_API_ROOT + this.urlString}?${$.param(opts)}`;
        };
      }
      comm = new ReportingComm({
        id: id,
        fetchOptions: fetchOptions
      });
      this.cfgs = args;
      this.cfgs.dataGroup = comm.dataGroup;
      this.cfgs.type = "series";
      this.subSection = args.subSection;
      this.report = this.cfgs.report;
      this.reportState = models.reportState;
      this.mainMeta = models.mainMeta;
      this.reportMeta = models.reportMeta;
      this.mainModel = models.mainModel;
      this.reportModel = reportModel = models.reportModel;
      this.reportModelObj = $.extend({}, reportModel.toJSON());
      this.currentReportId = this.report.id;
      this.campaign = models.campaign;
      this.currency = this.mainMeta.get("currency");
      this.totalModel = models.total;
      this.chartFiltersMetrics = args.chartFiltersMetrics;
      this.hasViewabilityFlag = T1Permissions.check("feature", "reporting_viewability");
      const focus = reportModel.get("focus");
      const strategyChannelFilter = `strategy_channel="${focus.toUpperCase()}"&campaign_id=`;
      const campaignGrossTimeKey = models.timeSeries.summary.fetchKey;
      const seriesTimeKey = models.timeSeries.daily.fetchKey;
      this.updateFetchOptionsDate(fetchOptions);
      if (focus !== "all") {
        fetchOptions.filter = strategyChannelFilter;
        models.totalStrategyChannel = $.extend(true, {}, models.total);
        models.totalStrategyChannel.fetchOptions.filter = strategyChannelFilter;
        models.summaryStrategyChannel = $.extend(true, {}, models.summary);
        models.summaryStrategyChannel.fetchOptions.filter = strategyChannelFilter;
        comm.buildModel("campaignModel", models.summaryStrategyChannel);
        comm.buildModel("totalModel", models.totalStrategyChannel);
      } else {
        comm.buildModel("campaignModel", $.extend(true, {}, models.summary));
        comm.buildModel("totalModel", $.extend(true, {}, models.total));
      }
      comm.dataGroup.campaignModel.fetchOptions.v2 = "";
      comm.dataGroup.totalModel.fetchOptions.v2 = "";
      const dim1Info = reportModel.get("dimensionInfo");
      this.dim1Key = dim1Info.key;
      this.dim1NameField = this.dim1Key === dim1Info.nameField ? "" : `,${dim1Info.nameField}`;
      const dim1DimensionParams = `campaign_id,${this.dim1Key}${this.dim1NameField}`;
      comm.buildCollection("dim1Collection", models.summaryCollection, {
        dimensions: dim1DimensionParams,
        time_rollup: campaignGrossTimeKey
      });
      comm.buildCollection("dim1FilteredCollection", models.summaryCollection, {
        dimensions: dim1DimensionParams,
        time_rollup: campaignGrossTimeKey
      });
      comm.dataGroup.dim1FilteredCollection.url = makeFetchURL();
      comm.buildCollection("campaignNestedCollection", new CampaignReport({
        urlString: "std/technology",
        fetchOptions: $.extend({}, fetchOptions, {
          dimensions: "organization_id",
          time_rollup: seriesTimeKey
        }),
        url: fetchURL
      }));
      comm.buildCollection("totalNestedCollection", new CampaignReport({
        urlString: "std/technology",
        fetchOptions: $.extend({}, fetchOptions, {
          dimensions: "organization_id",
          time_rollup: seriesTimeKey
        }),
        url: fetchURL2
      }));
      comm.buildCollection("collection", new CampaignReport({
        urlString: "std/technology",
        fetchOptions: $.extend({}, fetchOptions, {
          dimensions: dim1DimensionParams,
          time_rollup: seriesTimeKey
        }),
        url: fetchURL2
      }));
      comm.buildCollection("dim1FilteredNestedCollection", new CampaignReport({
        urlString: "std/technology",
        fetchOptions: $.extend({}, fetchOptions, {
          dimensions: dim1DimensionParams,
          time_rollup: seriesTimeKey
        }),
        url: fetchURL2
      }));
      comm.buildCollection("dimensionItemsCollection", models.dimensionItemsCollection, {
        time_rollup: "all"
      });
      const dim2Info = reportModel.get("dim2Info");
      this.dim2Key = dim2Info && dim2Info.key;
      const dim2NameField = dim2Info && dim2Info.nameField;
      this.dim2NameField = this.dim2Key === dim2NameField ? "" : `,${dim2NameField}`;
      const dim2DimensionParams = `campaign_id,${this.dim2Key || ""}${this.dim2NameField}`;
      comm.buildCollection("dim2Collection", models.summaryCollection, {
        dimensions: dim2DimensionParams,
        time_rollup: campaignGrossTimeKey
      });
      comm.buildCollection("collection2", new CampaignReport({
        fetchOptions: $.extend({}, fetchOptions, {
          dimensions: dim2DimensionParams,
          time_rollup: seriesTimeKey
        }),
        url: fetchURL,
        urlString: "std/technology"
      }));
      comm.buildCollection("tempDimensionCollection2", models.dimensionItemsCollection, {
        time_rollup: "all"
      });
      this.deviceTypeColl = comm.buildCollection("deviceTypeColl", new CampaignReport({
        fetchOptions: $.extend({}, fetchOptions, {
          dimensions: this.dimKey_device_type,
          time_rollup: campaignGrossTimeKey
        }),
        url: makeFetchURL("device"),
        urlString: "std/device_technology"
      }));
      this.inventoryTypeColl = comm.buildCollection("inventoryTypeColl", new CampaignReport({
        fetchOptions: $.extend({}, fetchOptions, {
          dimensions: this.dimKey_inventory_type,
          time_rollup: campaignGrossTimeKey
        }),
        url: makeFetchURL("inventory"),
        urlString: "std/device_technology"
      }));
      this.handleDataProxy = $.proxy(this.handleData, this);
    },
    initLayouts() {
      const cfgs = this.cfgs;
      this.gridInited = false;
      this.layout = new T1Layout({
        el: () => this.$(".w-report-panel"),
        template: layout,
        layout: {
          ".report-chart": [{
            module: "reporting/campaigns/technology",
            options: cfgs,
            viewType: "chart"
          }],
          ".report-controls": [{
            module: "reporting/campaigns/technology",
            options: cfgs,
            viewType: "controls"
          }],
          ".report-grid": [{
            module: "reporting/campaigns/technology",
            options: cfgs,
            viewType: "grid"
          }]
        }
      });
      this.layout.serialize = () => ({
        chartHidden: !this.chartShown
      });
    },
    updateFetchOptionsDate(fetchOptions) {
      const {
        mainModel: mainModel,
        reportModel: reportModel
      } = this.cfgs.models;
      const dateFormat = "yyyy-MM-dd";
      if (reportModel.get("isCTD")) {
        fetchOptions.time_window = "campaign_to_date";
      } else {
        fetchOptions.order = "date";
        if (reportModel.get("startDate")) {
          fetchOptions.start_date = mainModel.getDateString(reportModel.get("startDate"));
          fetchOptions.end_date = mainModel.getDateString(reportModel.get("endDate"));
        } else {
          fetchOptions.start_date = Utils.defaultStartDate.toString(dateFormat);
          fetchOptions.end_date = Utils.defaultEndDate.toString(dateFormat);
        }
      }
    },
    loadTempDimensions() {
      this.setGetDataOnce();
      this.getDataOnce().then(this.handleDataProxy);
    },
    changeDimension() {
      this.reportModel.resetColumnResize();
      this.reportModel.resetHiddenItems();
      this.load();
    },
    timer(category, label, startStop) {
      T1Timer[startStop]({
        category: category,
        label: label
      });
    },
    needsDataLoad() {
      return this.unloaded || this.currentReportId !== this.report.id || this.prevDim1Key !== this.dim1Key || this.prevDim2Key !== this.dim2Key || this.prevReportStart !== this.report.start || this.prevReportEnd !== this.report.end || this.prevCurrency !== this.currency || this.prevMoreFilters !== this.moreFilters;
    },
    resetData() {
      if (comm) {
        comm.clearDataGroup();
        comm = null;
      }
    },
    load() {
      const {
        mainModel: mainModel,
        reportModel: reportModel
      } = this;
      const dim1Info = reportModel.get("dimensionInfo");
      const dim2Info = reportModel.get("dim2Info");
      if (mainModel.leftTheSection(this.section)) {
        return;
      }
      this.dim1Key = dim1Info.key;
      this.dim1NameField = this.dim1Key === dim1Info.nameField ? "" : `,${dim1Info.nameField}`;
      this.dim2Key = dim2Info && dim2Info.key;
      const dim2NameField = dim2Info && dim2Info.nameField;
      this.dim2NameField = this.dim2Key === dim2NameField ? "" : `,${dim2NameField}`;
      this.chartShown = mainModel.get("chartShown") === "true";
      this.currency = mainModel.get("currency");
      this.moreFilters = reportModel.getTechFilters();
      mainModel.setTrackingSection(trackingSection);
      if (this.needsDataLoad()) {
        reportModel.resetColorData();
        this.setGetDataOnce();
      } else {
        reportModel.setCollectionFetchParams(comm.dataGroup.collection.fetchOptions, this.urlSuffix);
      }
      this.unloaded = false;
      if (this.layout) {
        this.layout.unload();
      }
      this.initLayouts();
      this.render().then(() => {
        this.layout.load();
        this.$loader = this.$(".loader-container");
        this.getDataOnce().then(this.handleDataProxy);
        this.prevDim1Key = this.dim1Key;
        this.prevDim2Key = this.dim2Key;
        this.prevReportStart = this.report.start;
        this.prevReportEnd = this.report.end;
        this.prevCurrency = this.currency;
        this.prevFilteredParams = this.filterParams;
        this.prevMoreFilters = this.moreFilters;
      });
    },
    toggleLoader(show) {
      const animTime = 200;
      if (show) {
        this.$loader.fadeIn(animTime);
      } else {
        this.$loader.fadeOut(animTime);
      }
    },
    setGetDataOnce() {
      this.getDataOnce = _.once(this.getData);
    },
    getData() {
      let areFiltersApplied, dateRangeChanged, dim2FetchOptionsExtend, dim2FetchParams, dim2FilteredItems, dim2FilteredOutCount, dim2UrlParams, filteredInItemsList, needsLoadDeviceAndInventory, originalFilterIndex;
      const self = this;
      const {
        cfgs: cfgs,
        reportModel: reportModel,
        timer: timer
      } = this;
      const isCTD = reportModel.get("isCTD");
      const focus = reportModel.get("focus");
      const prevFocus = reportModel.get("prevFocus");
      let silent = false;
      const reportID = this.report.id;
      const section = "device_technology";
      const urlSuffix = "";
      const urlString = `std/${section}`;
      const dataGroup = comm.dataGroup;
      let dim1Name = "";
      const dim1Info = reportModel.get("dimensionInfo");
      const tempDim1 = reportModel.get("tempDimension");
      const tempDim1Info = reportModel.get("tempDimensionInfo");
      let dim1Collection = dataGroup.summaryCollection;
      let dim1NestedCollection = tempDim1 ? dataGroup.dimensionItemsCollection : dataGroup.collection;
      let dim1FilteredCollection = dataGroup.dim1FilteredCollection;
      let dim1FilteredNestedCollection = dataGroup.dim1FilteredNestedCollection;
      let dim2Name = "";
      let dim2NameField = "";
      const dim2Info = reportModel.get("dim2Info");
      const tempDim2 = reportModel.get("tempDim2");
      const tempDim2Info = reportModel.get("tempDim2Info");
      let dim2Collection = dataGroup.dimensionCollection2;
      const doLoadDim2 = Boolean(tempDim2Info && tempDim2Info.key || dim2Info && dim2Info.key);
      const chartFiltersMetricsStr = this.chartFiltersMetrics.toString();
      const campaignModelDeferred = T1UtilsAsync.makeDeferral();
      const campaignNestedCollectionDeferred = T1UtilsAsync.makeDeferral();
      const dim1CollectionDeferred = T1UtilsAsync.makeDeferral();
      const dim1NestedCollectionDeferred = T1UtilsAsync.makeDeferral();
      const dim1FilteredCollectionDeferred = T1UtilsAsync.makeDeferral();
      const dim1FilteredNestedCollectionDeferred = T1UtilsAsync.makeDeferral();
      const dim2CollectionDeferred = T1UtilsAsync.makeDeferral();
      const dim2NestedCollectionDeferred = T1UtilsAsync.makeDeferral();
      const deviceTypeCollDeferred = T1UtilsAsync.makeDeferral();
      const inventoryTypeCollDeferred = T1UtilsAsync.makeDeferral();
      const campaignFetchOptionsExtend = {};
      let requestMetrics = Object.keys(this.reportMeta.getRequestMetrics()).toString();
      const promises = [campaignModelDeferred.promise, campaignNestedCollectionDeferred.promise, dim1CollectionDeferred.promise, dim1FilteredCollectionDeferred.promise, dim1FilteredNestedCollectionDeferred.promise, dim2CollectionDeferred.promise, deviceTypeCollDeferred.promise, inventoryTypeCollDeferred.promise];
      if (!reportID) {
        return;
      }
      if (!(tempDim1Info && tempDim1Info.key) && !(tempDim2Info && tempDim2Info.key)) {
        this.toggleLoader(true);
      }
      this.updateFetchOptionsDate(campaignFetchOptionsExtend);
      timerValue = reportID;
      this.currentReportId = reportID;
      this.urlSuffix = urlSuffix;
      this.mainCallsDone = false;
      comm.reportID = reportID;
      comm.urlString = urlString;
      const campaignModel = comm.resetDataItem("campaignModel", $.extend(true, campaignFetchOptionsExtend, {
        order: isCTD ? "" : "date"
      }));
      campaignModel.filteredDimensionIDs = "";
      campaignModel.noTechFilters = true;
      this.campaignFetchOptionsExtend = campaignFetchOptionsExtend;
      const campaignNestedCollection = comm.resetDataItem("campaignNestedCollection", campaignFetchOptionsExtend);
      comm.resetDataItem("totalModel", campaignFetchOptionsExtend);
      this.totalNestedCollection = comm.resetDataItem("totalNestedCollection", campaignFetchOptionsExtend);
      this.totalNestedCall = this.totalNestedCollection;
      if (tempDim1Info) {
        dim1Name = tempDim1Info.nameField;
      } else if (dim1Info) {
        dim1Name = dim1Info.nameField;
      }
      dim1Name = dim1Name.toUpperCase().replace(/[ ]/g, "_");
      if (tempDim1) {
        this.dim1Key = tempDim1Info.key;
        this.dim1NameField = this.dim1Key === tempDim1Info.nameField ? "" : `,${tempDim1Info.nameField}`;
        silent = true;
      }
      const campaignFetchParams = this.mainModel.getMultiCampaignExtCols(this.dim1Key);
      const dim1FetchParams = this.dim1Key !== "campaign_name" ? this.dim1Key + this.dim1NameField : "";
      const dim1FetchOptionsExtend = {
        dimensions: campaignFetchParams + dim1FetchParams
      };
      $.extend(dim1FetchOptionsExtend, campaignFetchOptionsExtend);
      if (!tempDim1) {
        reportModel.setCollectionFetchParams(dim1NestedCollection.fetchOptions, urlSuffix);
      }
      this.dim2Key = dim2Info && dim2Info.key;
      dim2NameField = dim2Info && dim2Info.nameField;
      this.dim2NameField = this.dim2Key === dim2NameField ? "" : `,${dim2NameField}`;
      const dim2DimensionParams = (this.dim2Key || "") + this.dim2NameField;
      const multiDimFetchOptionsExtend = $.extend(true, {}, dim1FetchOptionsExtend, {
        dimensions: `${campaignFetchParams + dim1FetchParams},${this.dimKey_device_type},${this.dimKey_inventory_type},${dim2DimensionParams}`,
        metrics: chartFiltersMetricsStr
      });
      dim1Collection = comm.resetDataItem("dim1Collection", multiDimFetchOptionsExtend);
      dim1Collection.comparator = function (model) {
        return model.get(self.dim1Key);
      };
      dim1NestedCollection = comm.resetDataItem("dim1NestedCollection", dim1FetchOptionsExtend, dim1NestedCollection);
      dim1NestedCollection.filteredDimensionIDs = dim1NestedCollection.filteredDimensionIDs || "";
      const deviceTypeColl = comm.resetDataItem("deviceTypeColl", $.extend(true, campaignFetchOptionsExtend, {
        metrics: chartFiltersMetricsStr
      }));
      deviceTypeColl.comparator = function (model) {
        return model.get(self.dimKey_device_type);
      };
      const inventoryTypeColl = comm.resetDataItem("inventoryTypeColl", $.extend(true, campaignFetchOptionsExtend, {
        metrics: chartFiltersMetricsStr
      }));
      inventoryTypeColl.comparator = function (model) {
        return model.get(self.dimKey_inventory_type);
      };
      if (focus !== "all") {
        originalFilterIndex = dim1FilteredCollection.fetchOptions.filter.lastIndexOf("strategy_channel");
      } else {
        originalFilterIndex = dim1FilteredCollection.fetchOptions.filter.lastIndexOf("campaign_id");
      }
      const originalFilter = dim1FilteredCollection.fetchOptions.filter.substring(originalFilterIndex);
      if (doLoadDim2) {
        if (tempDim2Info && tempDim2Info.nameField) {
          dim2Name = tempDim2Info.nameField;
        } else if (dim2Info && dim2Info.nameField) {
          dim2Name = dim2Info.nameField;
        }
        dim2Name = dim2Name.toUpperCase().replace(/[ ]/g, "_");
        if (tempDim2 && tempDim2Info) {
          this.dim2Key = tempDim2Info.key;
          this.dim2NameField = this.dim2Key === tempDim2Info.nameField ? "" : `,${tempDim2Info.nameField}`;
          silent = true;
        }
        dim2FetchParams = this.dim2Key !== "campaign_name" ? this.dim2Key + this.dim2NameField : "";
        dim2FetchOptionsExtend = {
          dimensions: campaignFetchParams + dim2FetchParams
        };
        filteredInItemsList = reportModel.get("filteredInItems") || [];
        areFiltersApplied = reportModel.get("filteredOutCount") > 0;
        if (filteredInItemsList.length) {
          filteredInItemsList = reportModel.getEscapedNames(filteredInItemsList);
        }
        if (dim1Name === "OPERATING_SYSTEM" && dim2Name === "OS_VERSION" && areFiltersApplied) {
          dim2FetchOptionsExtend.filter = `operating_system=${filteredInItemsList.toString()}&campaign_id=`;
        }
        if (dim1Name === "BROWSER" && dim2Name === "BROWSER_VERSION" && areFiltersApplied) {
          dim2FetchOptionsExtend.filter = `browser=${filteredInItemsList.toString()}&campaign_id=`;
        }
        $.extend(dim2FetchOptionsExtend, campaignFetchOptionsExtend);
        dim2Collection = comm.resetDataItem("dim2Collection", dim2FetchOptionsExtend);
        dim2Collection.comparator = function (model) {
          return model.get(self.dim2Key);
        };
        dim1FilteredCollection = comm.resetDataItem("dim1FilteredCollection", dim1FetchOptionsExtend);
        dim1FilteredCollection.comparator = function (model) {
          return model.get(self.dim1Key);
        };
        dim1FilteredNestedCollection = comm.resetDataItem("dim1FilteredNestedCollection", dim1FetchOptionsExtend);
        dim1FilteredNestedCollection.filteredDimensionIDs = dim1FilteredNestedCollection.filteredDimensionIDs || "";
        dim2FilteredItems = reportModel.get("filteredInItemsDim2") || [];
        dim2FilteredOutCount = reportModel.get("filteredOutCountDim2") || 0;
        if (dim2FilteredItems.length) {
          dim2FilteredItems = reportModel.getEscapedNames(dim2FilteredItems);
        }
        dim2UrlParams = this.dim2Key && dim2FilteredItems.length && dim2FilteredOutCount > 0 ? `${this.dim2Key}=${dim2FilteredItems.toString()}&` : "";
        dim1FilteredCollection.fetchOptions.filter = dim2UrlParams + originalFilter;
        dim1FilteredNestedCollection.fetchOptions.filter = dim2UrlParams + originalFilter;
        if (!tempDim2) {
          reportModel.setCollectionFetchParams(dim1FilteredNestedCollection.fetchOptions, urlSuffix);
        }
      } else {
        dim1FilteredCollection = comm.dataGroup.dim1FilteredCollection;
        dim1FilteredCollection.reset();
        dim1FilteredNestedCollection = comm.dataGroup.dim1FilteredNestedCollection;
        dim1FilteredNestedCollection.reset();
        dim1FilteredCollection.fetchOptions.filter = originalFilter;
        dim1FilteredNestedCollection.fetchOptions.filter = originalFilter;
      }
      if (!this.hasViewabilityFlag) {
        requestMetrics = Object.keys(_.omit(this.reportMeta.getRequestMetrics(), MetricColl.viewability)).toString();
      }
      campaignModel.fetchOptions.metrics = requestMetrics;
      campaignNestedCollection.fetchOptions.metrics = requestMetrics;
      dim1Collection.fetchOptions.metrics = requestMetrics;
      dim1NestedCollection.fetchOptions.metrics = requestMetrics;
      dim1FilteredCollection.fetchOptions.metrics = requestMetrics;
      dim1FilteredNestedCollection.fetchOptions.metrics = requestMetrics;
      if (dim2Collection) {
        dim2Collection.fetchOptions.metrics = requestMetrics;
      }
      this.abortAjaxCalls(true);
      timer(GAMap.combinedLoad, timerValue, "start");
      function loadCampaignDataHandler() {
        timer(GAMap.campaignApiLoad, timerValue, "start");
        campaignModel.loaded = false;
        campaignModel.fetch({
          onSuccess: function () {
            timer(GAMap.campaignApiLoad, timerValue, "stop");
            campaignModel.loaded = true;
            campaignModelDeferred.resolve();
          },
          onError: function (error) {
            throw new Error(`campaignModel fetch failed: ${error}`);
          }
        });
      }
      function loadDim1DataHandler() {
        timer(GAMap.dim1ApiLoad + dim1Name, timerValue, "start");
        dim1Collection.loaded = false;
        if (tempDim1) {
          cfgs.models.tempDim1Coll = dim1Collection;
        }
        dim1Collection.fetch({
          silent: silent,
          onSuccess: function () {
            self.tempDim1Data = tempDim1 ? dim1Collection : null;
            timer(GAMap.dim1ApiLoad + dim1Name, timerValue, "stop");
            dim1Collection.loaded = true;
            reportModel.setReportInfo(section, dim1Collection.ajxResponseHeaders);
            dim1CollectionDeferred.resolve();
          },
          onError: function (error) {
            throw new Error(`dim1Collection fetch failed: ${error}`);
          }
        });
      }
      function loadDim1FilteredDataHandler() {
        timer(GAMap.dim1ApiLoad + dim1Name, timerValue, "start");
        dim1FilteredCollection.loaded = false;
        dim1FilteredCollection.fetch({
          silent: silent,
          onSuccess: function () {
            timer(GAMap.dim1ApiLoad + dim1Name, timerValue, "stop");
            dim1FilteredCollection.loaded = true;
            dim1FilteredCollectionDeferred.resolve();
          },
          onError: function (error) {
            throw new Error(`dim1FilteredCollection fetch failed: ${error}`);
          }
        });
      }
      function loadDim2DataHandler() {
        timer(GAMap.dim2ApiLoad + dim2Name, timerValue, "start");
        dim2Collection.loaded = false;
        if (tempDim2) {
          cfgs.models.tempDim2Coll = dim2Collection;
        }
        dim2Collection.fetch({
          silent: silent,
          onSuccess: function () {
            self.tempDim2Data = tempDim2 ? dim2Collection : null;
            timer(GAMap.dim2ApiLoad + dim2Name, timerValue, "stop");
            dim2Collection.loaded = true;
            dim2CollectionDeferred.resolve();
          },
          onError: function (error) {
            throw new Error(`dim2Collection fetch failed: ${error}`);
          }
        });
      }
      function loadCampaignNestedDataHandler() {
        timer(GAMap.campaignNestedApiLoad, timerValue, "start");
        campaignNestedCollection.loaded = false;
        campaignNestedCollection.fetch({
          silent: silent,
          onSuccess: function () {
            timer(GAMap.campaignNestedApiLoad, timerValue, "stop");
            campaignNestedCollection.loaded = true;
            campaignNestedCollectionDeferred.resolve();
          },
          onError: function (error) {
            throw new Error(`campaignNestedCollection fetch failed: ${error}`);
          }
        });
      }
      function loadDim1FilteredNestedDataHandler() {
        timer(GAMap.dim1NestedApiLoad + dim1Name, timerValue, "start");
        dim1FilteredNestedCollection.loaded = false;
        dim1FilteredNestedCollection.fetch({
          silent: silent,
          onSuccess: function () {
            timer(GAMap.dim1NestedApiLoad + dim1Name, timerValue, "stop");
            dim1FilteredNestedCollection.loaded = true;
            dim1FilteredNestedCollectionDeferred.resolve();
          },
          onError: function (error) {
            throw new Error(`dim1FilteredNestedCollection fetch failed: ${error}`);
          }
        });
      }
      reportModel.resetDateRangeChanged();
      if (tempDim1) {
        loadDim1DataHandler();
        campaignModelDeferred.resolve();
        campaignNestedCollectionDeferred.resolve();
        dim1NestedCollectionDeferred.resolve();
        dim1FilteredCollectionDeferred.resolve();
        dim1FilteredNestedCollectionDeferred.resolve();
        dim2CollectionDeferred.resolve();
        dim2NestedCollectionDeferred.resolve();
        deviceTypeCollDeferred.resolve();
        inventoryTypeCollDeferred.resolve();
      } else if (tempDim2) {
        loadDim2DataHandler();
        campaignModelDeferred.resolve();
        campaignNestedCollectionDeferred.resolve();
        dim1CollectionDeferred.resolve();
        dim1NestedCollectionDeferred.resolve();
        dim1FilteredCollectionDeferred.resolve();
        dim1FilteredNestedCollectionDeferred.resolve();
        dim2NestedCollectionDeferred.resolve();
        deviceTypeCollDeferred.resolve();
        inventoryTypeCollDeferred.resolve();
      } else {
        dateRangeChanged = this.prevReportStart !== undefined && (this.prevReportStart !== this.report.start || this.prevReportEnd !== this.report.end);
        if (dateRangeChanged) {
          reportModel.resetOnDateRangeChange();
        }
        loadCampaignDataHandler();
        if (isCTD) {
          campaignNestedCollectionDeferred.resolve();
        } else {
          loadCampaignNestedDataHandler();
        }
        loadDim1DataHandler();
        if (doLoadDim2) {
          loadDim1FilteredDataHandler();
          if (isCTD) {
            dim1FilteredNestedCollectionDeferred.resolve();
          } else {
            loadDim1FilteredNestedDataHandler();
          }
          dim2CollectionDeferred.resolve();
        } else {
          dim1FilteredCollection = comm.resetDataItem("dim1FilteredCollection", dim1FetchOptionsExtend);
          dim1FilteredCollection.comparator = function (model) {
            return model.get(self.dim1Key);
          };
          dim1FilteredNestedCollection = comm.resetDataItem("dim1FilteredNestedCollection", dim1FetchOptionsExtend);
          dim1FilteredNestedCollection.filteredDimensionIDs = dim1FilteredNestedCollection.filteredDimensionIDs || "";
          loadDim1FilteredDataHandler();
          if (isCTD) {
            dim1FilteredNestedCollectionDeferred.resolve();
          } else {
            loadDim1FilteredNestedDataHandler();
          }
          dim2CollectionDeferred.resolve();
        }
        this.filterParams = this.getFilterParams(true);
        reportModel.setFilterParams(this.filterParams);
        needsLoadDeviceAndInventory = dateRangeChanged || this.prevFilteredParams !== undefined && this.prevFilteredParams !== this.filterParams || prevFocus !== undefined && prevFocus !== focus;
        if (needsLoadDeviceAndInventory) {
          reportModel.setDeviceData(undefined, true);
          reportModel.setInventoryData(undefined, true);
          T1.EventHub.publish("load:donutData");
          this.deviceTypeCollDeferred = deviceTypeCollDeferred;
          this.inventoryTypeCollDeferred = inventoryTypeCollDeferred;
          this.loadDeviceTypeCollHandler();
          this.loadInventoryTypeCollHandler();
        } else {
          deviceTypeCollDeferred.resolve();
          inventoryTypeCollDeferred.resolve();
        }
        reportModel.set({
          prevFocus: focus
        });
      }
      return T1UtilsAsync.linkPromises(promises);
    },
    loadDeviceTypeCollHandler() {
      const deviceTypeColl = this.deviceTypeColl;
      deviceTypeColl.loaded = false;
      deviceTypeColl.fetch({
        silent: false,
        onSuccess: () => {
          this.deviceLoaded = true;
          deviceTypeColl.loaded = true;
          this.deviceTypeCollDeferred.resolve();
        },
        onError: function (error) {
          throw new Error(`deviceTypeColl fetch failed: ${error}`);
        }
      });
    },
    loadInventoryTypeCollHandler() {
      const inventoryTypeColl = this.inventoryTypeColl;
      inventoryTypeColl.loaded = false;
      inventoryTypeColl.fetch({
        silent: false,
        onSuccess: () => {
          this.inventoryLoaded = true;
          inventoryTypeColl.loaded = true;
          this.inventoryTypeCollDeferred.resolve();
        },
        onError: function (error) {
          throw new Error(`inventoryTypeColl fetch failed: ${error}`);
        }
      });
    },
    handleData() {
      if (this.mainModel.leftTheSection(this.section)) {
        return;
      }
      const reportModel = this.reportModel;
      const tempDim1 = reportModel.get("tempDimension");
      const tempDim2 = reportModel.get("tempDim2");
      const dataGroup = comm.dataGroup;
      this.timer(GAMap.combinedLoad, this.report.id, "stop");
      if (tempDim1) {
        reportModel.setDimensionItems({
          applying: false,
          dim1Data: this.tempDim1Data,
          dim1FilteredData: null,
          dim2Data: null
        });
      }
      if (tempDim2) {
        reportModel.setDimensionItems({
          applying: false,
          dim1Data: null,
          dim1FilteredData: null,
          dim2Data: this.tempDim2Data
        });
      }
      if (!tempDim1 && !tempDim2) {
        reportModel.setDimensionItems({
          applying: true,
          dim1Data: dataGroup.dim1Collection,
          dim1FilteredData: dataGroup.dim1FilteredCollection,
          dim2Data: null,
          metrics: this.chartFiltersMetrics
        }, {
          deviceLoadedSeparately: this.deviceLoaded,
          inventoryLoadedSeparately: this.inventoryLoaded
        });
        if (dataGroup.dim1Collection.models.length && !reportModel.get("isCTD")) {
          reportModel.setTimeSeriesSlots(this.campaignFetchOptionsExtend, "device_technology");
        }
        this.mainCallsDone = true;
        T1.EventHub.publish("responseHeadersReady", reportModel.get("reportInfo").reportTypes.device_technology);
        this.getTotalData(true);
        if (this.deviceLoaded) {
          reportModel.setDeviceData(this.deviceTypeColl.toJSON());
        }
        if (this.inventoryLoaded) {
          reportModel.setInventoryData(this.inventoryTypeColl.toJSON());
        }
      }
      this.dim1Loaded = this.deviceLoaded = this.inventoryLoaded = false;
      this.toggleLoader(false);
    },
    getFilterParams(calledFromGetData) {
      let urlParams;
      const {
        reportModel: reportModel,
        dim1Key: dim1Key,
        dim2Key: dim2Key
      } = this;
      let dim1FilteredItems = reportModel.get("filteredInItems") || [];
      const dim1FilteredOutCount = reportModel.get("filteredOutCount") || 0;
      let dim2FilteredItems = reportModel.get("filteredInItemsDim2") || [];
      const dim2FilteredOutCount = reportModel.get("filteredOutCountDim2") || 0;
      let filterUsed = false;
      const timeToRead = 8e3;
      const displayDelay = 500;
      if (dim1FilteredItems.length) {
        dim1FilteredItems = reportModel.getEscapedNames(dim1FilteredItems);
      }
      if (dim2FilteredItems.length) {
        dim2FilteredItems = reportModel.getEscapedNames(dim2FilteredItems);
      }
      if (dim1Key === "deal_id") {
        urlParams = dim1FilteredItems.length ? `&${dim1Key}=${dim1FilteredItems.toString()}` : "";
      } else {
        filterUsed = dim1Key && dim1FilteredItems.length && dim1FilteredOutCount > 0;
        if (calledFromGetData && filterUsed) {
          if (dim1Key === "inventory_type" && dim1FilteredItems.includes("In-Application")) {
            this.displayWarning('Filtering to Inventory Type: "In-Application" is not available at this time.' + "<br>Please choose another filter setting.", timeToRead, displayDelay);
          }
        }
        urlParams = filterUsed ? `&${dim1Key}=${dim1FilteredItems.toString()}` : "";
      }
      if (dim2Key) {
        urlParams += dim2Key && dim2FilteredItems.length && dim2FilteredOutCount > 0 ? `&${dim2Key}=${dim2FilteredItems.toString()}` : "";
      }
      return urlParams;
    },
    displayWarning(msg, duration, delay) {
      setTimeout(function () {
        T1.Notify("message", msg, duration);
      }, delay);
    },
    getTotalData(noDeviceInventoryLoad) {
      if (this.mainCallsDone && this.gridInited && this.reportModel.get("dimensionItemsCount") > 0) {
        this.getTotal(noDeviceInventoryLoad);
      }
    },
    getTotal(noDeviceInventoryLoad) {
      if (this.mainModel.leftTheSection(this.section)) {
        return;
      }
      const self = this;
      const {
        reportModel: reportModel,
        timer: timer
      } = this;
      const {
        totalModel: totalModel,
        totalNestedCollection: totalNestedCollection
      } = comm.dataGroup;
      const changeEvent = "panel.filteredItemsChange";
      const totalModelDeferred = T1UtilsAsync.makeDeferral();
      const totalNestedCollectionDeferred = T1UtilsAsync.makeDeferral();
      const deviceTypeCollDeferred = T1UtilsAsync.makeDeferral();
      const inventoryTypeCollDeferred = T1UtilsAsync.makeDeferral();
      let requestMetrics = Object.keys(this.reportMeta.getRequestMetrics()).toString();
      const promises = [totalModelDeferred.promise, totalNestedCollectionDeferred.promise, deviceTypeCollDeferred.promise, inventoryTypeCollDeferred.promise];
      if (!this.hasViewabilityFlag) {
        requestMetrics = Object.keys(_.omit(this.reportMeta.getRequestMetrics(), MetricColl.viewability)).toString();
      }
      totalModel.fetchOptions.metrics = requestMetrics;
      totalNestedCollection.fetchOptions.metrics = requestMetrics;
      timerValue = this.report.id;
      const urlParams = this.filterParams = this.getFilterParams();
      reportModel.setFilterParams(urlParams);
      this.abortTotalAjaxCalls();
      totalNestedCollection.loaded = false;
      T1.EventHub.publish(changeEvent, false);
      function loadTotalHandler() {
        timer(GAMap.totalApiLoad, timerValue, "start");
        totalModel.filteredDimensionIDs = urlParams;
        totalModel.loaded = false;
        totalModel.fetch({
          onSuccess: function () {
            timer(GAMap.totalApiLoad, timerValue, "stop");
            totalModel.loaded = true;
            totalModelDeferred.resolve();
          },
          onError: function (error) {
            throw new Error(`total fetch failed: ${error}`);
          }
        });
      }
      function loadTotalSeriesHandler() {
        timer(GAMap.totalNestedApiLoad, timerValue, "start");
        totalNestedCollection.filteredDimensionIDs = urlParams;
        totalNestedCollection.loaded = false;
        totalNestedCollection.fetch({
          onSuccess: function () {
            timer(GAMap.totalNestedApiLoad, timerValue, "stop");
            totalNestedCollection.loaded = true;
            totalNestedCollectionDeferred.resolve();
          },
          onError: function (error) {
            throw new Error(`total nested fetch failed: ${error}`);
          }
        });
      }
      loadTotalHandler();
      if (reportModel.get("isCTD")) {
        totalNestedCollection.loaded = true;
        totalNestedCollectionDeferred.resolve();
      } else {
        loadTotalSeriesHandler();
      }
      const needsLoadDeviceAndInventory = noDeviceInventoryLoad !== true && this.prevFilteredParams !== undefined && this.prevFilteredParams !== this.filterParams;
      if (needsLoadDeviceAndInventory) {
        reportModel.setDeviceData(undefined, true);
        reportModel.setInventoryData(undefined, true);
        T1.EventHub.publish("load:donutData");
        this.deviceTypeCollDeferred = deviceTypeCollDeferred;
        this.inventoryTypeCollDeferred = inventoryTypeCollDeferred;
        this.loadDeviceTypeCollHandler();
        this.loadInventoryTypeCollHandler();
      } else {
        deviceTypeCollDeferred.resolve();
        inventoryTypeCollDeferred.resolve();
      }
      T1UtilsAsync.linkPromises(promises).then(function () {
        if (!self.mainModel.leftTheSection(self.section)) {
          self.prevFilteredParams = self.filterParams;
          if (self.deviceLoaded) {
            reportModel.setDeviceData(self.deviceTypeColl.toJSON());
          }
          if (self.inventoryLoaded) {
            reportModel.setInventoryData(self.inventoryTypeColl.toJSON());
          }
          self.deviceLoaded = self.inventoryLoaded = false;
          T1.EventHub.publish(changeEvent, true);
        }
      });
    },
    getMoreFilters(techFilters) {
      switch (techFilters) {
        case "device":
        case "inventory":
          return "";
        default:
          return this.reportModel.getTechFilters();
      }
    },
    abortAjaxCalls(dontAbortTotal) {
      if (comm) {
        comm.abortAjaxCalls(["campaignModel", "campaignNestedCollection", "dim1Collection", "dim2Collection", "dim1NestedCollection", "dim2NestedCollection", "dim1FilteredCollection", "collection", "collection2", "dimensionItemsCollection", "dim1FilteredNestedCollection", "tempDimensionCollection2", "deviceTypeColl", "inventoryTypeColl"]);
      }
      if (!dontAbortTotal) {
        this.abortTotalAjaxCalls();
      }
    },
    abortTotalAjaxCalls() {
      if (comm) {
        comm.abortAjaxCalls(["totalModel", "totalNestedCollection"]);
      }
    },
    unload() {
      this.abortAjaxCalls();
      this.resetData();
      this.unloaded = true;
    },
    serialize() {
      return {
        chartShown: this.chartShown
      };
    }
  });
});
